import $ from 'jquery';

$.fn.ariaExpanded = function(toggleOn) {
  return this.attr('aria-expanded', toggleOn);
};
